import React from 'react';
import Icon from '@ant-design/icons';

const SeeSVG = () => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={true}
  >
    <title>Icon / See</title>
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Icon-/-See" stroke="currentColor">
        <path
          d="M8,2.5 C12.9601324,2.5 15.0780293,7.05566214 15.4630596,7.99823002 C15.2166952,8.58948308 14.2706198,10.6183274 12.3691303,12.0444444 C11.2600954,12.8762206 9.82122624,13.5 8,13.5 C3.05988553,13.5 0.925612694,8.94294185 0.536921396,7.9999749 L0.536921396,7.9999749 L0.608957842,7.83155404 C0.937241726,7.08820779 1.87123656,5.26695491 3.61976903,3.95555556 C4.72898456,3.12364391 6.17074482,2.5 8,2.5 Z"
          id="Oval"
        />
        <circle id="Oval" cx="8" cy="8" r="2.5" />
      </g>
    </g>
  </svg>
);

export const JSee: React.FC<any> = (props) => {
  return <Icon component={SeeSVG} {...props}  aria-hidden={true}/>;
};
